<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>变量管理</el-breadcrumb-item>
      <el-breadcrumb-item>变量维护</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品按钮 -->
      <el-row>
        <el-col>
          <el-button type="success" @click="addDialogVisible = true">新增变量维护</el-button>
        </el-col>
      </el-row>
      <!-- 变量维护信息表格 -->
      <el-button
        icon="el-icon-download"
        circle
        @click="getpdfyes"
        class="download"
        type="warning"
        size="medium"
      ></el-button>
      <el-table id="pdfDom" :data="VariableList" border stripe ref="table">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="变量名称" prop="VariableName" width="110px"></el-table-column>
        <el-table-column label="PLC_ID" prop="PLC_ID" width="110px"></el-table-column>
        <el-table-column label="数据块" prop="DB_Block" width="110px"></el-table-column>
        <el-table-column label="起始地址" prop="StartAddress" width="110px"></el-table-column>
        <el-table-column label="读取数量" prop="Read_QTY" width="110px"></el-table-column>
        <el-table-column label="操作类型" prop="OperationType" width="110px"></el-table-column>
        <el-table-column label="数据类型" prop="DataType" width="110px"></el-table-column>
        <el-table-column label="小数精度" prop="DecimalPrecision" width="110px"></el-table-column>
        <el-table-column label="上行公式" prop="UpwardFormula" width="110px"></el-table-column>
        <el-table-column label="单位" prop="Unit" width="110px"></el-table-column>
        <el-table-column label="是否显示" prop="Is_Display" width="110px"></el-table-column>
        <el-table-column label="是否报警" prop="Is_Alarm" width="110px"></el-table-column>
        <el-table-column label="创建时间" prop="CreateTime" width="170px">
          <template slot-scope="scope">
            {{ scope.row.CreateTime | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="Remark" width="180px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeVariable(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15, 50, 100]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑变量维护信息的会话框 -->
    <el-dialog title="修改变量维护信息" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="变量名称" prop="VariableName">
          <el-input v-model="editForm.VariableName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="PLC" prop="PLC_ID">
          <el-select v-model="editForm.PLC_ID" placeholder="请选择">
            <el-option
              v-for="item in plcMessageList"
              :key="item.ID"
              :label="item.DeviceName"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型" prop="DataType">
          <!-- <el-input v-model="editForm.DataType" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="editForm.DataType" placeholder="请选择">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变量代码" prop="VariableCode">
          <el-input v-model="editForm.VariableCode" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品类型" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="数据块" prop="DB_Block" required>
          <el-input v-model="editForm.DB_Block" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="起始地址" prop="StartAddress">
          <el-input v-model="editForm.StartAddress" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="读取数量" prop="Read_QTY">
          <el-input v-model="editForm.Read_QTY" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="操作类型" prop="OperationType">
          <!-- <el-input v-model="editForm.OperationType" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="editForm.OperationType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小数精度" prop="DecimalPrecision">
          <el-input v-model="editForm.DecimalPrecision" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="上行公式" prop="UpwardFormula">
          <el-input v-model="editForm.UpwardFormula" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input v-model="editForm.Unit" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="Is_Display" required>
          <!-- <el-input v-model="addForm.Is_Alarm" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="editForm.Is_Display" placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否报警" prop="Is_Alarm">
          <!-- <el-input v-model="editForm.Is_Alarm" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="editForm.Is_Alarm" placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editVariable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加变量维护的对话框 -->
    <el-dialog title="添加变量维护" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="变量名称" prop="VariableName">
          <el-input v-model="addForm.VariableName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="PLC" prop="PLC_ID">
          <el-select v-model="addForm.PLC_ID" placeholder="请选择">
            <el-option
              v-for="item in plcMessageList"
              :key="item.ID"
              :label="item.DeviceName"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型" prop="DataType">
          <!-- <el-input v-model="addForm.DataType" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.DataType" placeholder="请选择">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变量代码" prop="VariableCode">
          <el-input v-model="addForm.VariableCode" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品类型" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="数据块" prop="DB_Block" required>
          <el-input v-model="addForm.DB_Block" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="起始地址" prop="StartAddress">
          <el-input v-model="addForm.StartAddress" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="读取数量" prop="Read_QTY">
          <el-input v-model="addForm.Read_QTY" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="操作类型" required>
          <!-- <el-input v-model="addForm.OperationType" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.OperationType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小数精度" prop="DecimalPrecision">
          <el-input v-model="addForm.DecimalPrecision" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="上行公式" prop="UpwardFormula">
          <el-input v-model="addForm.UpwardFormula" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input v-model="addForm.Unit" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="Is_Display" required>
          <!-- <el-input v-model="addForm.Is_Alarm" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.Is_Display" placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否报警" prop="Is_Alarm">
          <!-- <el-input v-model="addForm.Is_Alarm" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.Is_Alarm" placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVariable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_variable_maintenance'
            },
            getTypeList1: {
                page: '1',
                limit: '500',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_variable_maintenance'
            },
            // 变量维护列表
            VariableList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 添加用户的表单数据
            addForm: {
                VariableCode: '',
                VariableName: '',
                StartAddress: '',
                CreateTime: '',
                Read_QTY: '',
                OperationType: '',
                DecimalPrecision: '',
                UpwardFormula: '',
                Unit: '',
                Is_Alarm: '',
                Remark: '',
                DataType: '',
                DB_Block: '',
                Is_Display: '',
                PLC_ID: ''
            },
            //添加表单的验证规则对象
            addFormRules: {
                VariableName: [
                    { required: true, message: '请输入变量名称', trigger: 'blur' }
                ],
                VariableCode: [
                    { required: true, message: '请输入变量代码', trigger: 'blur' },
                ],
                CreateTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                Is_Alarm: [
                    { required: true, message: '请输入是否报警', trigger: 'blur' }
                ],
                StartAddress: [
                    { required: true, message: '请输入起始地址', trigger: 'blur' }
                ],
                Read_QTY: [
                    { required: true, message: '请输入读取数量', trigger: 'blur' },
                ],
                OperationType: [
                    { required: true, message: '请输入操作类型', trigger: 'blur' }
                ],
                DecimalPrecision: [
                    { required: true, message: '请输入小数精度', trigger: 'blur' }
                ]
            },
            // 修改表单的验证规则对象
            editFormRules: {
                VariableName: [
                    { required: true, message: '请输入变量名称', trigger: 'blur' }
                ],
                VariableCode: [
                    { required: true, message: '请输入变量代码', trigger: 'blur' },
                ],
                CreateTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                Is_Alarm: [
                    { required: true, message: '请输入是否报警', trigger: 'blur' }
                ],
                StartAddress: [
                    { required: true, message: '请输入起始地址', trigger: 'blur' }
                ],
                Read_QTY: [
                    { required: true, message: '请输入读取数量', trigger: 'blur' },
                ],
                OperationType: [
                    { required: true }
                ],
                DecimalPrecision: [
                    { required: true, message: '请输入小数精度', trigger: 'blur' }
                ]
            },
            // 操作类型
            options: [{
                value: '0',
                label: '可读'
            }, {
                value: '1',
                label: '可写'
            }, {
                value: '2',
                label: '可读可写'
            }],
            // 数据类型
            options1: [{
                value: '1',
                label: '两字节'
            },
            {
                value: '2',
                label: '四字节'
            },
            {
                value: '3',
                label: '字符串'
            }
            ],
            // 是否报警
            options2: [{
                value: 'Y',
                label: '是'
            }, {
                value: 'N',
                label: '否'
            }],
            // PLC信息表
            plcMessageList: []
        }
    },
    created () {
        this.getVariableList()
        this.getVariableList1()
        this.getPLC()
    },
    methods: {
        // 调用接口获取变量维护表
        async getVariableList () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].OperationType == '0') {
                    res.data[i].OperationType = '可读'
                }
                if (res.data[i].OperationType == '1') {
                    res.data[i].OperationType = '可写'
                }
                if (res.data[i].OperationType == '2') {
                    res.data[i].OperationType = '可读可写'
                }
                if (res.data[i].DataType == '1') {
                    res.data[i].DataType = '两字节'
                }
                if (res.data[i].DataType == '2') {
                    res.data[i].DataType = '四字节'
                }
                if (res.data[i].DataType == '3') {
                    res.data[i].DataType = '字符串'
                }
                if (res.data[i].Is_Alarm == 'Y') {
                    res.data[i].Is_Alarm = '是'
                }
                if (res.data[i].Is_Alarm == 'N') {
                    res.data[i].Is_Alarm = '否'
                }
                if (res.data[i].Is_Display == 'Y') {
                    res.data[i].Is_Display = '是'
                }
                if (res.data[i].Is_Display == 'N') {
                    res.data[i].Is_Display = '否'
                }
            }
            this.VariableList = res.data
        },
        async getVariableList1 () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList1 })
            console.log(res.data)
            this.total = res.data.length
        },
        // 调用接口删除变量
        async removeVariable (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该变量信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/deleteVariableMaintenance', params)
            console.log(res)
            if (res !== 1) {
                return this.$message.error('删除失败')
            }
            this.$message.success('删除成功！')
            this.getVariableList()
            this.getVariableList1()
        },
        // 展示修改变量的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].OperationType == '0') {
                    res.data[i].OperationType = '可读'
                }
                if (res.data[i].OperationType == '1') {
                    res.data[i].OperationType = '可写'
                }
                if (res.data[i].OperationType == '2') {
                    res.data[i].OperationType = '可读可写'
                }
                if (res.data[i].DataType == '1') {
                    res.data[i].DataType = '两字节'
                }
                if (res.data[i].DataType == '2') {
                    res.data[i].DataType = '四字节'
                }
                if (res.data[i].DataType == '3') {
                    res.data[i].DataType = '字符串'
                }
            }
            this.editForm = res.data[0]
            console.log(this.editForm)
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口新增变量维护
        addVariable () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("DataType", this.addForm.DataType)
                params.append("VariableCode", this.addForm.VariableCode)
                params.append("VariableName", this.addForm.VariableName)
                params.append("StartAddress", this.addForm.StartAddress)
                params.append("CreateTime", this.addForm.CreateTime)
                params.append("Read_QTY", this.addForm.Read_QTY)
                params.append("OperationType", this.addForm.OperationType)
                params.append("DecimalPrecision", this.addForm.DecimalPrecision)
                params.append("UpwardFormula", this.addForm.UpwardFormula)
                params.append("Unit", this.addForm.Unit)
                params.append("Is_Alarm", this.addForm.Is_Alarm)
                params.append("Remark", this.addForm.Remark)
                params.append("DB_Block", this.addForm.DB_Block)
                params.append("Is_Display", this.addForm.Is_Display)
                params.append("PLC_ID", this.addForm.PLC_ID)
                console.log('123' + params)
                // 可以发起添加用户的网络请求
                const { data: res } = await this.$http.post('/WMS/InsertVariableMaintenance', params)
                console.log('1234' + res)
                if (res != 1) {
                    return this.$message.error('添加变量信息失败!')
                }
                this.$message.success('添加变量维护信息成功！')
                // 隐藏添加用户的对话框
                this.addDialogVisible = false
                // 重新获取用户列表数据
                this.getVariableList()
                this.getVariableList1()
            })
        },
        // 调用接口编辑变量
        editVariable () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                if (this.editForm.OperationType == '可读') {
                    this.editForm.OperationType = '0'
                }
                if (this.editForm.OperationType == '可写') {
                    this.editForm.OperationType = '1'
                }
                if (this.editForm.OperationType == '可读可写') {
                    this.editForm.OperationType = '2'
                }
                if (this.editForm.DataType == '两字节') {
                    this.editForm.DataType = '1'
                }
                if (this.editForm.DataType == '四字节') {
                    this.editForm.DataType = '1'
                }
                if (this.editForm.DataType == '字符串') {
                    this.editForm.DataType = '3'
                }
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("DataType", this.editForm.DataType)
                params.append("VariableCode", this.editForm.VariableCode)
                params.append("VariableName", this.editForm.VariableName)
                params.append("StartAddress", this.editForm.StartAddress)
                params.append("CreateTime", this.editForm.CreateTime)
                params.append("Read_QTY", this.editForm.Read_QTY)
                params.append("OperationType", this.editForm.OperationType)
                params.append("DecimalPrecision", this.editForm.DecimalPrecision)
                params.append("UpwardFormula", this.editForm.UpwardFormula)
                params.append("Unit", this.editForm.Unit)
                params.append("Is_Alarm", this.editForm.Is_Alarm)
                params.append("Remark", this.editForm.Remark)
                params.append("ID", this.editForm.ID)
                params.append("DB_Block", this.editForm.DB_Block)
                params.append("Is_Display", this.editForm.Is_Display)
                params.append("PLC_ID", this.editForm.PLC_ID)
                console.log('888' + params)
                const { data: res } = await this.$http.post('/WMS/updateVariableMaintenance', params)
                if (res !== 1) {
                    this.$message.error('更新变量维护信息失败！')
                }
                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getVariableList()
                this.getVariableList1()
                // 提示修改成功
                this.$message.success('更新变量维护信息成功！')
            })
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            // console.log(newSize)
            this.queryInfo.pagesize = newSize
            this.getVariableList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.queryInfo.pagenum = newPage
            this.getVariableList()
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getVariableList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getVariableList()
        },
        getpdfyes () {
            this.getPdf()
        },
        // 调用接口获取PLC信息
        async getPLC () {
            const { data: res } = await this.$http.get('/WMS/queryPlc', { params: this.getTypeList })
            console.log(res.data)
            this.plcMessageList = res.data
        }
    }
}
</script>

<style lang="less" scoped>
.download {
  position:sticky;
  transform: translate(35%, -140%);
}
</style>
